import React, { useState } from "react";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { useSearchParams } from "react-router-dom";

const Privacy = () => {
  const [searchParams] = useSearchParams();
  const isModule = searchParams.get("app");

  return (
    <>
      {isModule === "true" ? [] : <HeaderLayout />}
      <div>
        <div
          style={{
            padding: "2rem",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <h2 align="center">Privacy Policy</h2>

          <p>
            At <strong>Bonoxi</strong>, accessible from{" "}
            <a
              href="https://www.bonoxi.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.bonoxi.com
            </a>
            , we are committed to protecting your privacy. This Privacy Policy
            explains what information we collect, how we use it, and your rights
            related to your data.
          </p>

          <h3>1. Information We Collect</h3>
          <ul>
            <li>
              <strong>Uploaded Files:</strong> Documents (Word, Excel,
              PowerPoint) uploaded for conversion.
            </li>
            <li>
              <strong>QR Code Data:</strong> Text or links provided to generate
              QR codes.
            </li>
            <li>
              <strong>Device and Usage Data:</strong> IP address, browser type,
              operating system, and usage logs.
            </li>
            <li>
              <strong>Contact Information:</strong> Only if voluntarily provided
              through contact forms.
            </li>
          </ul>

          <h3>2. How We Use Your Information</h3>
          <ul>
            <li>To process file-to-PDF conversions.</li>
            <li>To generate and deliver QR codes.</li>
            <li>To improve website performance and functionality.</li>
            <li>
              To communicate with you regarding support or service updates (only
              if you initiate contact).
            </li>
          </ul>

          <h3>3. File and Data Security</h3>
          <ul>
            <li>Uploaded files are automatically deleted after processing.</li>
            <li>
              We do not store or share any user-generated QR code content or
              documents permanently.
            </li>
            <li>All data transmission is secured with HTTPS encryption.</li>
          </ul>

          <h3>4. Third-Party Services</h3>
          <p>
            We may use third-party tools like analytics or hosting providers.
            These services may collect certain data to help us monitor and
            improve our platform. We ensure they comply with industry-standard
            privacy regulations.
          </p>

          <h3>5. Your Rights</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Request deletion of any data you've submitted.</li>
            <li>Opt-out of any future communications.</li>
          </ul>
          <p>
            To exercise these rights, contact us at:{" "}
            <a href="mailto:support@bonoxi.com">support@bonoxi.com</a>
          </p>

          <h3>6. Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. The updated
            version will be posted on this page with the revised date.
          </p>
          <hr />
          <p>
            <strong>Effective Date:</strong> May 15, 2025
          </p>
        </div>
      </div>
      {isModule === "true" ? [] : <FooterLayout />}
    </>
  );
};

export default Privacy;
